const MINUTE = 60 * 1000;

export default date => (date
  ? (new Date(date.getTime() - (date.getTimezoneOffset() * MINUTE)))
    .toISOString()
    .substring(0, 10)
    .replace(/-/g, '')
  : undefined);
